<template>
  <div>
    <top-navbar></top-navbar>
    <div class="background_color mb-5">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Assets
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Manage Assets(SCADA)
      </h6>

      <div style="margin-top: 0px;" class="container-fluid">
        <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">
          <div class="d-flex">
            <b-input-group size="sm" style="max-width: 225px;">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Search"
                class="bdr-rad"
                @input="loadAssets"
              ></b-form-input>
            </b-input-group>
            <div style="margin-top: -8px; margin-bottom: -6px;" class="ms-2">
              <span class="custom-breadcrumb">Showing {{ currentPage }}-{{ currentPage * perPage }} of {{ totalRows }} items.</span>
            </div>
          </div>
          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button class="btn btn-sm btn-outline-primary mt-0 bdr-rad font-size_def" @click="$router.push('/cmmsassets/create')">
              Create Asset
            </button>
            <!-- <button class="btn btn-sm btn-outline-primary mt-0 bdr-rad font-size_def" @click="$router.push('/cmmsassets/index')">
              Manage Assets
            </button> -->
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-center" v-if="isInitialLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div v-else>
              <div class="table-responsive">
              <b-table
                small
                show-empty
                responsive
                hover
                style="font-size: small;"
                class="table-hover"
                :items="all_datas"
                :fields="fields"
                :current-page="currentPage"
                :filter="filter"
                head-variant="dark"
              >
                <template #head(I_pcode)="data">
                  <div>{{ data.label }}</div>
                  <b-form-input v-model="columnFilters.I_pcode" size="sm" placeholder="Filter" @input="applyColumnFilters"></b-form-input>
                </template>
                <template #head(i_pdescription)="data">
                  <div>{{ data.label }}</div>
                  <b-form-input v-model="columnFilters.i_pdescription" size="sm" placeholder="Filter" @input="applyColumnFilters"></b-form-input>
                </template>
                <template #head(barcode)="data">
                  <div>{{ data.label }}</div>
                  <b-form-input v-model="columnFilters.barcode" size="sm" placeholder="Filter" @input="applyColumnFilters"></b-form-input>
                </template>
                <template #head(serial_number)="data">
                  <div>{{ data.label }}</div>
                  <b-form-input v-model="columnFilters.serial_number" size="sm" placeholder="Filter" @input="applyColumnFilters"></b-form-input>
                </template>
                <template #head(asset_class)="data">
                  <div>{{ data.label }}</div>
                  <b-form-input v-model="columnFilters.asset_class" size="sm" placeholder="Filter" @input="applyColumnFilters"></b-form-input>
                </template>
                <template #head(category)="data">
                  <div>{{ data.label }}</div>
                  <b-form-input v-model="columnFilters.category" size="sm" placeholder="Filter" @input="applyColumnFilters"></b-form-input>
                </template>
                <template #head(branch)="data">
                  <div>{{ data.label }}</div>
                  <b-form-input v-model="columnFilters.branch" size="sm" placeholder="Filter" @input="applyColumnFilters"></b-form-input>
                </template>
                <template #head(department)="data">
                  <div>{{ data.label }}</div>
                  <b-form-input v-model="columnFilters.department" size="sm" placeholder="Filter" @input="applyColumnFilters"></b-form-input>
                </template>
                <template #head(location)="data">
                  <div>{{ data.label }}</div>
                  <b-form-input v-model="columnFilters.location" size="sm" placeholder="Filter" @input="applyColumnFilters"></b-form-input>
                </template>
                <template #head(custodian_name)="data">
                  <div>{{ data.label }}</div>
                  <b-form-input v-model="columnFilters.custodian_name" size="sm" placeholder="Filter" @input="applyColumnFilters"></b-form-input>
                </template>
                <template #head(I_created_date)="data">
                  <div>{{ data.label }}</div>
                  <b-form-input v-model="columnFilters.I_created_date" size="sm" placeholder="Filter" @input="applyColumnFilters"></b-form-input>
                </template>
                <template #head(actions)="data">
                  <div>{{ data.label }}</div>
                </template>
                <template #cell(actions)="row">
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad "
                      type="button"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Action
                    </button>
                    <div class="dropdown-menu bdr-rad">
                      <a class="dropdown-item mouse-cursor" @click="viewAsset(row.item.id)">View</a>
                    </div>
                  </div>
                </template>
              </b-table>
              </div>
              <b-pagination
                v-model="currentPage"
                size="sm"
                pills
                :total-rows="totalRows"
                :per-page="perPage"
                @change="pageChanged"
              ></b-pagination>
            </div>
          </div>
        </div>
        <br><br>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      filter: '',
      all_datas: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      isInitialLoading: true,
      columnFilters: {
        I_pcode: '',
        i_pdescription: '',
        barcode: '',
        serial_number: '',
        asset_class: '',
        category: '',
        branch: '',
        department: '',
        location: '',
        custodian_name: '',
        I_created_date: '',
      },
      fields: [
        { key: 'I_pcode', label: 'Asset ID', sortable: true },
        { key: 'i_pdescription', label: 'Description', sortable: true },
        { key: 'barcode', label: 'Barcode', sortable: true },
        { key: 'serial_number', label: 'Serial Number', sortable: true },
        { key: 'asset_class', label: 'Asset Class', sortable: true },
        { key: 'category', label: 'Category', sortable: true },
        { key: 'branch', label: 'Branch', sortable: true },
        { key: 'department', label: 'Department', sortable: true },
        { key: 'location', label: 'Location', sortable: true },
        { key: 'custodian_name', label: 'Custodian', sortable: true },
        { key: 'I_created_date', label: 'Created Date', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
    };
  },
  mounted() {
    this.loadAssets(this.currentPage, true);
  },
  methods: {
    pageChanged(newPage) {
      this.loadAssets(newPage, false);
    },

    applyColumnFilters() {
      this.currentPage = 1;
      this.loadAssets(1, false);
    },

    viewAsset(id) {
      this.$router.push('/cmmsassets/excel-view?id=' + id);
    },

    async loadAssets(page = this.currentPage, showInitialLoading = false) {
      if (showInitialLoading) {
        this.isInitialLoading = true;
      }
      try {
        const { data } = await axios.get('/ciinventory/indexscada-excel', {
          params: {
            page,
            perPage: this.perPage,
            filter: this.filter,
            columnFilters: this.columnFilters,
          },
          headers: { Authorization: 'Bearer ' + this.access_token },
        });
        this.all_datas = data.all_data || [];
        this.totalRows = Number(data.total_count || 0);
        this.currentPage = Number(data.page || page);
      } catch (error) {
        console.log(error.response || error);
      } finally {
        if (showInitialLoading) {
          this.isInitialLoading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.font1 { font-size: 13px !important; }
.decoration { text-decoration: none; color: white !important; }
.manage-boder { border-bottom: 2px solid #007bff; border-top: 2px solid #007bff; padding: 10px !important; }
.bdr-rad { border-radius: 12px; }
.bdr-rad2 { border-radius: 15px; }
.navbar { border-bottom: 0 !important; }
.mouse-cursor { cursor: pointer; }
</style>
